/**
 * @generated SignedSource<<30b0321224bbf1de1dbd47fe55fae84a>>
 * @relayHash c3a7bca030fc0dbeab35daf894140cf1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 91478798917b9e25bc8ab211335cd3b588cc7a1a28f53685fa36f1c5be0ec96b

import type { ConcreteRequest, Query } from 'relay-runtime';
export type KnowledgeGraphContentType = "BLOGPOST" | "PAGE" | "%future added value";
export type KnowledgeGraphObjectType = "snippet_v1" | "snippet_v2" | "snippet_v2_180" | "snippet_v2_300" | "%future added value";
export type aiSnippetLoaderQuery$variables = {
  cloudId: string;
  contentId: string;
  contentType: KnowledgeGraphContentType;
  includeMe: boolean;
  objectType: KnowledgeGraphObjectType;
};
export type aiSnippetLoaderQuery$data = {
  readonly confluence_latestKnowledgeGraphObjectV2: {
    readonly __typename: "KnowledgeGraphObjectResponseV2";
    readonly objectData: string;
  } | null | undefined;
  readonly me?: {
    readonly user: {
      readonly accountId: string;
      readonly name: string;
    } | null | undefined;
  };
};
export type aiSnippetLoaderQuery = {
  response: aiSnippetLoaderQuery$data;
  variables: aiSnippetLoaderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentType"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeMe"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "objectType"
},
v5 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v6 = {
  "args": [
    {
      "kind": "Variable",
      "name": "cloudId",
      "variableName": "cloudId"
    },
    {
      "kind": "Variable",
      "name": "contentId",
      "variableName": "contentId"
    },
    {
      "kind": "Variable",
      "name": "contentType",
      "variableName": "contentType"
    },
    {
      "kind": "Variable",
      "name": "objectType",
      "variableName": "objectType"
    }
  ],
  "concreteType": "KnowledgeGraphObjectResponseV2",
  "kind": "LinkedField",
  "name": "confluence_latestKnowledgeGraphObjectV2",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    {
      "kind": "ScalarField",
      "name": "objectData"
    }
  ]
},
v7 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v8 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "aiSnippetLoaderQuery",
    "selections": [
      (v6/*: any*/),
      {
        "condition": "includeMe",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "AuthenticationContext",
            "kind": "LinkedField",
            "name": "me",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v8/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "aiSnippetLoaderQuery",
    "selections": [
      (v6/*: any*/),
      {
        "condition": "includeMe",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "AuthenticationContext",
            "kind": "LinkedField",
            "name": "me",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "id"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "91478798917b9e25bc8ab211335cd3b588cc7a1a28f53685fa36f1c5be0ec96b",
    "metadata": {},
    "name": "aiSnippetLoaderQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "1f0cd3e05c5b730bfbdefb0883c1d8b4";

export default node;
